// src/components/MenuReception.jsx

import React from "react";
import { NavLink } from "react-router-dom";

import "./MainMenu.css";

export default function MenuReception() {

  return (

    <div
      className="main-menu-wrapper"
      style={{
        height: "80vh",
        overflow: "auto",
        padding: "25px",
        paddingBottom: "100px",
      }}
    >

      <div className="main-menu-container">


        {/* =====================================================
            DASHBOARD
        ===================================================== */}

        <NavLink
          to="/frontdesk"
          className={({ isActive }) =>
            `main-menu-card ${
              isActive ? "active" : ""
            }`
          }
        >

          <div className="menu-icon dashboard-icon">

            <i className="fa fa-tachometer"></i>

          </div>


          <div className="menu-info">

            <span className="menu-small-title">
              Overview
            </span>

            <span className="menu-title">
              Dashboard
            </span>

          </div>


          <div className="menu-arrow">

            <i className="fa fa-angle-right"></i>

          </div>

        </NavLink>



        {/* =====================================================
            PATIENT INFO
        ===================================================== */}

        <NavLink
          to="/newprofile"
          className={({ isActive }) =>
            `main-menu-card ${
              isActive ? "active" : ""
            }`
          }
        >

          <div className="menu-icon patient-icon">

            <i className="fa fa-address-book-o"></i>

          </div>


          <div className="menu-info">

            <span className="menu-small-title">
              Management
            </span>

            <span className="menu-title">
              Patient Info
            </span>

          </div>


          <div className="menu-arrow">

            <i className="fa fa-angle-right"></i>

          </div>

        </NavLink>



        {/* =====================================================
            QUEUE STATUS
        ===================================================== */}

        <NavLink
          to="/qstatus"
          className={({ isActive }) =>
            `main-menu-card ${
              isActive ? "active" : ""
            }`
          }
        >

          <div className="menu-icon queue-icon">

            <i className="fa fa-users"></i>

          </div>


          <div className="menu-info">

            <span className="menu-small-title">
              Management
            </span>

            <span className="menu-title">
              Queue Status
            </span>

          </div>


          <div className="menu-arrow">

            <i className="fa fa-angle-right"></i>

          </div>

        </NavLink>



        {/* =====================================================
            PROCEDURE

            Doctor
            Admin
            Reception
            Nursing Station
        ===================================================== */}

        <NavLink
          to="/procedure"
          className={({ isActive }) =>
            `main-menu-card ${
              isActive ? "active" : ""
            }`
          }
        >

          <div className="menu-icon proc-icon">

            <i className="fa fa-medkit"></i>

          </div>


          <div className="menu-info">

            <span className="menu-small-title">
              Follow-up
            </span>

            <span className="menu-title">
              Procedure
            </span>

          </div>


          <div className="menu-arrow">

            <i className="fa fa-angle-right"></i>

          </div>

        </NavLink>


      </div>

    </div>

  );

}